var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetailIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21833",
    "data-name": "\\uADF8\\uB8F9 21833",
    transform: "translate(-556 -1318)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28204",
    "data-name": "\\uC0AC\\uAC01\\uD615 28204",
    width: 24,
    height: 24,
    transform: "translate(556 1318)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21831",
    "data-name": "\\uADF8\\uB8F9 21831",
    transform: "translate(556.651 1318.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21832",
    "data-name": "\\uADF8\\uB8F9 21832",
    transform: "translate(0.615 0.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10296",
    "data-name": "\\uD328\\uC2A4 10296",
    d: "M21.515,10.249a1.435,1.435,0,0,1,.951,1.313c0,.058,0,.115,0,.171s0,.114,0,.172a1.435,1.435,0,0,1-.951,1.313l-1.407.5a1.383,1.383,0,0,0-.847.815q-.1.283-.223.557a1.4,1.4,0,0,0,.038,1.166l.632,1.324a1.426,1.426,0,0,1-.252,1.6c-.088.091-.179.182-.27.27a1.426,1.426,0,0,1-1.6.252l-1.323-.632a1.4,1.4,0,0,0-1.167-.038q-.274.121-.556.223a1.382,1.382,0,0,0-.816.846l-.5,1.407a1.434,1.434,0,0,1-1.313.951l-.171,0-.171,0a1.434,1.434,0,0,1-1.313-.951l-.5-1.407a1.382,1.382,0,0,0-.816-.846q-.283-.1-.557-.223a1.4,1.4,0,0,0-1.166.038l-1.323.632a1.425,1.425,0,0,1-1.6-.252c-.092-.088-.182-.179-.27-.27a1.425,1.425,0,0,1-.252-1.6l.632-1.323a1.405,1.405,0,0,0,.038-1.167q-.121-.274-.223-.557a1.383,1.383,0,0,0-.847-.815l-1.407-.5A1.433,1.433,0,0,1,1,11.9c0-.058,0-.115,0-.171s0-.113,0-.17a1.435,1.435,0,0,1,.951-1.314l1.407-.5a1.383,1.383,0,0,0,.847-.815q.1-.283.223-.557a1.4,1.4,0,0,0-.038-1.166L3.759,5.885a1.426,1.426,0,0,1,.252-1.6c.089-.091.179-.182.27-.27a1.425,1.425,0,0,1,1.6-.252l1.324.632a1.4,1.4,0,0,0,1.165.038q.274-.121.557-.223a1.383,1.383,0,0,0,.816-.846l.5-1.407A1.433,1.433,0,0,1,11.563,1l.171,0,.171,0a1.433,1.433,0,0,1,1.313.951l.5,1.407a1.383,1.383,0,0,0,.816.846q.283.1.556.223a1.4,1.4,0,0,0,1.166-.038l1.324-.632a1.425,1.425,0,0,1,1.6.252c.091.089.182.179.27.27a1.425,1.425,0,0,1,.252,1.6l-.632,1.324a1.4,1.4,0,0,0-.038,1.165q.121.274.223.557a1.383,1.383,0,0,0,.846.815ZM11.734,8.577a3.2,3.2,0,0,1,3.157,3.157,3.2,3.2,0,0,1-3.157,3.157,3.2,3.2,0,0,1-3.157-3.157,3.2,3.2,0,0,1,3.157-3.157Z",
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#343a40",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailIcon3);
export default __webpack_public_path__ + "static/media/DetailIcon3.c055bfc79420cc32527f4aad7c391734.svg";
export { ForwardRef as ReactComponent };